export const orderedProductCategories = [
    "cut-flower",
    "bucket",
    "bouquet",
    "dried-flower",
    "wreath",
    "potted-plant",
    "csa",
];
export function isRealProductCategoryKey(key) {
    return orderedProductCategories.includes(key);
}
export const realProductCategories = {
    "cut-flower": {
        id: "cut-flower",
        name: "Cut Flower",
        slug: "cut-flowers",
        pluralName: "Cut Flowers",
    },
    bucket: {
        id: "bucket",
        name: "Bucket",
        slug: "buckets",
        pluralName: "Buckets",
    },
    bouquet: {
        id: "bouquet",
        name: "Bouquet",
        slug: "bouquets",
        pluralName: "Bouquets",
    },
    "dried-flower": {
        id: "dried-flower",
        slug: "dried-flowers",
        name: "Dried Flower",
        pluralName: "Dried Flowers",
    },
    wreath: {
        id: "wreath",
        name: "Wreath",
        slug: "wreaths",
        pluralName: "Wreaths",
    },
    "potted-plant": {
        id: "potted-plant",
        name: "Potted Plant",
        slug: "potted-plants",
        pluralName: "Potted Plants",
    },
    csa: {
        id: "csa",
        slug: "csas",
        name: "CSA & Subscription",
        pluralName: "CSAs & Subscriptions",
    },
};
export const allProductCategories = Object.assign(Object.assign({}, realProductCategories), { "ad-hoc": {
        id: "ad-hoc",
        name: "Ad Hoc",
        slug: "ad-hoc",
        pluralName: "Ad Hoc",
    } });
export function getProductCategoryBySlug(slug) {
    return Object.values(allProductCategories).find((category) => category.slug === slug);
}
//# sourceMappingURL=categories.js.map